import { render, staticRenderFns } from "./EditarDependencia.vue?vue&type=template&id=507f9704&scoped=true&"
import script from "./EditarDependencia.vue?vue&type=script&lang=js&"
export * from "./EditarDependencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f9704",
  null
  
)

export default component.exports